import { Modal } from '@/components/ui/Modal/Modal';
import { Button } from '@/components/ui/Button/Button';
import { APP_VERSION, formatClientBuildDate, OZERO_DIGITAL_URL } from '@/lib/appVersion';
import './AboutAppModal.css';

export interface AboutAppModalProps {
  open: boolean;
  onClose: () => void;
}

export function AboutAppModal({ open, onClose }: AboutAppModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="О приложении"
      size="sm"
      headerVariant="island"
      scrollableBody={false}
      className="about-app-modal"
    >
      <div className="about-app-modal__inner">
        <p className="about-app-modal__version" aria-label={`Версия ${APP_VERSION}`}>
          v{APP_VERSION}
        </p>

        <p className="about-app-modal__buildDate">Дата сборки: {formatClientBuildDate()}</p>

        <div className="form__footer form__footer_modal about-app-modal__footer">
          <Button
            type="button"
            variant="primary"
            size="m"
            fullWidth
            className="about-app-modal__credit"
            onClick={() => window.open(OZERO_DIGITAL_URL, '_blank', 'noopener,noreferrer')}
          >
            Создано в ozero.digital
          </Button>
        </div>
      </div>
    </Modal>
  );
}
